__turbopack_context__.v({
  "directDepositCard": "DirectDepositInfo-module__PlgPsW__directDepositCard",
  "directDepositText": "DirectDepositInfo-module__PlgPsW__directDepositText",
});
